import { useTranslation } from 'react-i18next';
import { z } from 'zod';

export const useAdditionalInfoSchema = () => {
    const { t } = useTranslation();

    // Crie o esquema diretamente dentro do hook
    const schema = z.object({
      howToFindYogha: z.object({
        label: z.string({required_error:t('checkin.additionalInformation.forms.errors.howDidYouFindYogha')}).nonempty({
          message: t('checkin.additionalInformation.forms.errors.howDidYouFindYogha'),
        }),

        value: z.string({required_error:t('checkin.additionalInformation.forms.errors.howDidYouFindYogha')}).nonempty({
          message: t('checkin.additionalInformation.forms.errors.howDidYouFindYogha'),
        }),
      },{required_error: t('checkin.additionalInformation.forms.errors.howDidYouFindYogha')}),
      reasonToTrip: z.object({
        label: z.string({required_error:t('checkin.additionalInformation.forms.errors.reasonOfTheTrip')}).nonempty({
          message: t('checkin.additionalInformation.forms.errors.reasonOfTheTrip'),
        }),

        value: z.string({required_error:t('checkin.additionalInformation.forms.errors.reasonOfTheTrip')}).nonempty({
          message: t('checkin.additionalInformation.forms.errors.reasonOfTheTrip'),
        }),
      },{required_error: t('checkin.additionalInformation.forms.errors.reasonOfTheTrip')}),
      originCity: z.string({required_error:t('checkin.additionalInformation.forms.errors.cityOfOrigin')}).nonempty({
        message: t('checkin.additionalInformation.forms.errors.cityOfOrigin'),
      }),
      knownTheCity: z.enum(['Sim', 'Não'], {required_error:t('checkin.additionalInformation.forms.errors.didYouVisitTheCityBefore')}),
    }).superRefine((data,context) => {
    //   if(data.documentType === 'passport' && !data.documentNumber){
    //     context.addIssue({
    //       path: ['documentNumber'],
    //       code: 'custom',
    //       message: t('checkin.additionalInformation.forms.errors.passport')
    //     })
    //   }
    //   if(data.documentType === 'cpf' && !data.documentNumber){
    //     context.addIssue({
    //       path: ['documentNumber'],
    //       code: 'custom',
    //       message: t('checkin.additionalInformation.forms.errors.cpf')
    //     })
    //   }
    }
    );


    return schema;
  };
